export default __webpack_public_path__ + "img/cgoUKrvM.aa725661.svg";